import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';

import { PAATIntakeInfoModel } from '../../models';
import { FundingService } from '../../funding.service';

@Component({
   selector: 'pam-paat-intake-form',
   templateUrl: './paat-intake-form.component.html',
   styleUrls: ['./paat-intake-form.component.scss']
})
export class PAATIntakeFormComponent implements OnInit {
   @Input() enrollmentId: string;
   intake: PAATIntakeInfoModel;

   constructor (
      private fundingService: FundingService,
      private stateService: StateService
   ) { }

   ngOnInit() {
      this.getIntake();
   }

   private getIntake = () => {
      this.fundingService.getPAATIntakeInfo(this.enrollmentId).subscribe(result => {
         this.intake = result;
      });
   }

}
